export default __webpack_public_path__ + "static/media/box-title-community.f86a8b49.svg";